import { SamplesProPlan } from 'constants/brands';
import { Interval, SampleCatalog } from 'types/generated/subscriptionsApi';
import { t } from '@lingui/macro';
import getPlanPrices from '../../helpers/getPlanPrices';

const useSamplePlan = ({
    frequency,
    hasSubscription,
    samplesCatalog,
    getSaleDiscount,
}: {
    frequency: Interval;
    hasSubscription: boolean;
    samplesCatalog: SampleCatalog | undefined;
    getSaleDiscount: (
        planCode?: string,
        frequency?: Interval,
    ) => number | undefined;
}) => {
    const title = SamplesProPlan;
    const info = hasSubscription
        ? t`This will update your existing plan and billing date. You'll instantly get your new credits.`
        : undefined;

    const planByFrequency = samplesCatalog?.plans?.find(
        (plan) => plan?.frequency === frequency,
    );

    const discountPercentage = getSaleDiscount(
        planByFrequency?.code,
        frequency,
    );

    const {
        subscriptionPrice,
        monthlyEquivalentPrice,
        salePrice,
        monthlyEquivalentSale,
    } = getPlanPrices({
        subscriptionPrice: planByFrequency?.subscriptionPrice ?? 0,
        frequency,
        discountPercentage: discountPercentage,
    });

    return {
        code: planByFrequency?.code,
        currency: samplesCatalog?.currency,
        info,
        monthlyEquivalentPrice: monthlyEquivalentPrice,
        monthlyEquivalentSale: monthlyEquivalentSale,
        salePrice: salePrice,
        subscriptionPrice: subscriptionPrice,
        title,
    };
};

export default useSamplePlan;
